import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useGclid } from '../src/hooks/useGclid';
import { buildShopUrl, trackCTAClick } from '../src/utils/tracking';
interface CtaButtonProps {
  label: string;
  position: string;
  className?: string;
}
export function CtaButton({
  label,
  position,
  className = ''
}: CtaButtonProps) {
  const gclid = useGclid();
  const SHOP_URL = 'https://hunderunde.shop/products/futtertopping-magen-darm';
  const href = buildShopUrl(SHOP_URL, gclid);
  return <a href={href} onClick={() => trackCTAClick(label, position)} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center justify-center gap-2 bg-forest hover:bg-forest/90 text-cream font-serif font-bold text-lg px-8 py-4 rounded-full transition-all transform hover:scale-105 active:scale-95 shadow-lg ${className}`} data-id="element-54">
      {label}
      <ArrowRight size={20} data-id="element-55" />
    </a>;
}